import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f626bd72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-coluna-cabecalho-wrapper" }
const _hoisted_2 = { class: "ss-coluna-cabecalho-titulo" }
const _hoisted_3 = { class: "ss-coluna-cabecalho-acoes" }
const _hoisted_4 = {
  key: 0,
  class: "ant-table-column-sorter"
}
const _hoisted_5 = { class: "ant-table-column-sorter-inner" }
const _hoisted_6 = {
  role: "img",
  "aria-label": "Ordenar crescente",
  class: "anticon anticon-caret-up ant-table-column-sorter-up"
}
const _hoisted_7 = {
  role: "img",
  "aria-label": "caret-down",
  class: "anticon anticon-caret-down ant-table-column-sorter-down"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "ant-table-column-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.props.column.ordering === true || _ctx.exibirFiltroCabecalho)
      ? (_openBlock(), _createElementBlock("div", {
          key: _ctx.props.column.key,
          class: "ss-coluna-ordenada"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "ss-coluna-cabecalho-titulo-ordenacao",
              style: _normalizeStyle({ paddingRight: _ctx.paddingAcoesCabecalho })
            }, [
              _withDirectives(_createElementVNode("span", { class: "ant-table-column-title ss-coluna-cabecalho-titulo" }, _toDisplayString(_ctx.props.column.title), 513), [
                [_vShow, !_ctx.filtroCabecalhoAberto]
              ]),
              _withDirectives(_createElementVNode("span", _hoisted_2, " ", 512), [
                [_vShow, _ctx.filtroCabecalhoAberto]
              ]),
              _createElementVNode("div", _hoisted_3, [
                (_ctx.props.column.ordering === true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(), _createElementBlock("a", {
                          title: "Ordenação crescente",
                          key: 'ord-asc' + _ctx.props.column.key,
                          class: _normalizeClass([_ctx.ordenacaoAtiva(_ctx.obterIdentificadorCabecalho(), 'ASC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ordenarDados(_ctx.obterIdentificadorCabecalho(), 'ASC')))
                        }, [
                          _createElementVNode("span", _hoisted_6, [
                            _createVNode(_component_icone, { nome: "ordem-crescente" })
                          ])
                        ], 2)),
                        (_openBlock(), _createElementBlock("a", {
                          title: "Ordenação decrescente",
                          key: 'ord-desc' + _ctx.props.column.key,
                          class: _normalizeClass([_ctx.ordenacaoAtiva(_ctx.obterIdentificadorCabecalho(), 'DESC') ? 'ss-ordenacao-coluna-ativa' : 'ss-ordenacao-coluna']),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ordenarDados(_ctx.obterIdentificadorCabecalho(), 'DESC')))
                        }, [
                          _createElementVNode("span", _hoisted_7, [
                            _createVNode(_component_icone, { nome: "ordem-decrescente" })
                          ])
                        ], 2))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.exibirFiltroCabecalho)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: _normalizeClass(["ss-coluna-cabecalho-icone-filtro", _ctx.filtroLigado ? 'ss-coluna-cabecalho-icone-filtro-ativo' : '']),
                      title: "Filtrar coluna",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.alternarFiltroCabecalho && _ctx.alternarFiltroCabecalho(...args)), ["stop"]))
                    }, [
                      _createVNode(_component_icone, {
                        style: {"font-size":"18px"},
                        nome: "pesquisar"
                      })
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ], 4),
            (_ctx.filtroCabecalhoAberto)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "ss-coluna-cabecalho-filtro-sobreposto",
                  style: _normalizeStyle({ paddingRight: _ctx.paddingAcoesCabecalho })
                }, [
                  _createElementVNode("input", {
                    ref: "inputFiltroCabecalho",
                    value: _ctx.obtemValorFiltroCabecalho(),
                    class: "ant-input ss-coluna-cabecalho-filtro",
                    type: "text",
                    placeholder: "Filtrar...",
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.alterarFiltroCabecalho($event))),
                    onKeydown: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.fecharFiltroCabecalho && _ctx.fecharFiltroCabecalho(...args)), ["esc"])),
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                  }, null, 40, _hoisted_8)
                ], 4))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.props.column.title), 1)
        ]))
  ]))
}